import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import {
    getCurrentPathname,
    getQueryParameter,
    getTrueLayerCallbackResult,
    getWindowLocation
} from '../../iwRouter/LocationHelper';

export function useTrackOpenBankingCallback() {
    useEffect(() => {
        const referer = getQueryParameter(getWindowLocation(), 'referer');
        if (referer !== 'truelayer_callback') {
            return;
        }
        // Params are cleared by TrueLayer.tsx (the modal), not here — clearing
        // them here would strip them before its alert can read them.
        const url = getCurrentPathname();
        switch (getTrueLayerCallbackResult()?.kind) {
            case 'success':
                tracking.ampli.openBankingLinkedSuccessfully({ url });
                break;
            case 'cancel':
                tracking.ampli.openBankingLinkingCancelled({ url });
                break;
            case 'failure':
            case 'provider_migrated':
                tracking.ampli.openBankingLinkingFailed({ url });
                break;
        }
    }, []);
}
